import { Injectable } from '@angular/core';
import { LocalStorageKeys } from '../../../LocalStorageKeys';
import { getXClientId } from '../../../utils/deviceUtils';
import { LocalStorageService } from '../../local-storage/local-storage.service';
import { RegionAPIResult } from '../../location/models/region-result';
import { StorefrontPolicyModel } from './model/StorefrontPolicyModels';

@Injectable({
  providedIn: 'root',
})
export class StorefrontPolicyService {
  private defaultEN = 'en-US';
  private defaultES = 'es-MX';
  private _reg: string;
  private _channels: string;
  private _devType: string;
  constructor(private localStorage: LocalStorageService) {}

  getPolicy(includePrd = false): StorefrontPolicyModel {
    const policy = new StorefrontPolicyModel();
    const profile = this.getSelectedProfile();
    const devTyp = this._devType ? this._devType : 'web';
    policy.reg = this._reg ? this._reg : this.localStorage.getItem(LocalStorageKeys.COUNTRY_CODE)?.toLowerCase() ?? 'us';
    policy.client = getXClientId();
    policy.pf = profile ? profile.pt : 'main';
    policy.dt = devTyp;
    policy.ipr = true;
    policy.acl = 'en';
    if (includePrd) {
      policy.prd = 'unowtve';
    }
    const unChannels = this._channels ?? this.localStorage.getItem(LocalStorageKeys.CHANNEL);
    if (unChannels) policy.un_channels = unChannels;
    return policy;
  }

  getProfile() {
    const profile = this.getSelectedProfile();
    return profile ? profile.pt : 'main';
  }

  getLang(): string {
    const lang = this.localStorage.getItem(LocalStorageKeys.LANG);
    return lang ?? 'es';
  }

  getLocale(): string {
    const lang = this.localStorage.getItem(LocalStorageKeys.LANG);
    if (lang === 'es') return 'es-US';
    if (lang == 'en') return 'en-US';
    return 'es-US';
  }

  getFallbacks(lang: string) {
    if (lang === 'es') {
      return this.defaultES;
    } else {
      return this.defaultEN;
    }
  }

  setRegion(region: string) {
    this._reg = region;
  }

  setDeviceType(devTyp: string) {
    this._devType = devTyp;
  }

  setChannels(location: RegionAPIResult) {
    this._channels = (location?.channel ?? []).toString();
  }

  private getSelectedProfile() {
    const profile = this.localStorage.getItem(LocalStorageKeys.SELECTED_PROFILE);
    return profile && profile !== 'undefined' ? JSON.parse(profile) : undefined;
  }
}
